import React from 'react'
import { useNavigate } from 'react-router-dom'

import yamadumiAuth from '../../Auth'
import { extractTelemetryAttributes } from '../../Insights'
import { CommonActions, useAppDispatch } from '../../stores'
import { useUnsafeOnceCall } from '../../components/hooks'
import { UserInfo } from '../../services'
import { LoginGateway } from '../../gateway/system/LoginGateway'

import { AuthenticateProgress } from './AuthenticateProgress'
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js'

export default function LoginRedirect() {
  const [error, setError] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const onceCall = useUnsafeOnceCall()
  const appInsights = useAppInsightsContext()

  React.useEffect(() => {
    // React.StrictModeでは、開発環境においてコンポーネントを２回マウントする。
    // そのとき、以下の認証処理も２回呼ばれてしまい、
    // ２回目が必ずエラーになってしまう。
    // それを回避するために、１回だけ呼び出すようにしている。
    // （２回目がエラーになってしまうと、トークンのリフレッシュができなくなる）
    onceCall(() => {
      yamadumiAuth.completeAuthentication()
        .then(async code => {
          const info = await yamadumiAuth.getUserInfo<UserInfo>()
          if (info == null) { throw new Error('認証認可サーバからユーザ情報の取得に失敗しました。') }
          const prop = await LoginGateway.login()
          if (prop == null) { throw new Error('ユーザ情報が登録されていません。') }

          appInsights.trackEvent(
            { name: 'XgrabLogin' },
            extractTelemetryAttributes(info))

          dispatch(CommonActions.login({
            authenticationCode: code,
            userInfo: info,
            userProp: prop
          }))

          navigate('/', { replace: true })
        })
        .catch((error: Error) => {
          setError(true)
          setErrorMessage(error.message)
        })
    })
  })

  return <AuthenticateProgress
    message={error ? 'ログイン処理中にエラーが発生しました' : 'ログイン処理中です...'}
    subMessage={errorMessage}
    returnToHomeButton={error} />
}
